const questionrecallcolumns = [
  {
    key: "id",
    label: "Question Id",
  },
   
  {
    key: "name",
    label: "Statement",
  },
  {
    key: "recallName",
    label: "RecallName",
  },
  {
    key: "categoryName",
    label: "Category Name",
  },
  {
    key: "onOfOptions",
    label: "On Of Options",
  },
   
  {
    key: "correctAnswer",
    label: "correctAnswer",
  },
  {
    key: "actions",
    label: "Actions",
  },
];
export { questionrecallcolumns };
